import React, { useState } from "react";
import { TodoListGroup } from "@/api/types";
import { Input } from "@/components/ui/input.tsx";
import { Button } from "@/components/ui/button.tsx";
import * as Dialog from "@radix-ui/react-dialog";
import {
	collapsedGroupsState,
	deleteStateEntry,
	groupsState,
	listsState,
	setStateEntry,
	uiState,
} from "@/states.ts";
import { deleteGroup, updateGroup } from "@/api/offline.ts";
import { processQueue } from "@/api/queue.ts";

export interface EditGroupDialogProps {
	group: TodoListGroup;
}

const EditGroupDialog: React.FC<EditGroupDialogProps> = (props) => {
	const [title, setTitle] = useState(props.group.title);

	const handleUpdate = () => {
		const newGroup = { ...props.group, title };
		updateGroup(newGroup).then((g) => {
			setStateEntry(groupsState.groups, g.group, "merge");
		});
		processQueue();
		uiState.editingGroup = null;
	};

	const handleDelete = () => {
		const group = uiState.editingGroup!;
		deleteGroup(group).then(() => {
			deleteStateEntry(groupsState, "groups", group);
			listsState.lists = listsState.lists.map((l) =>
				l.group_id === group.id ? { ...l, group_id: null } : l,
			);
			delete collapsedGroupsState.groups[group.id];
		});
		processQueue();
		uiState.editingGroup = null;
	};

	const handleClose = () => {
		uiState.editingGroup = null;
	};

	return (
		<Dialog.Root open={true}>
			<Dialog.Portal>
				<Dialog.Overlay className="DialogOverlay" />
				<Dialog.Content className="DialogContent">
					<div className={"p-4 flex flex-col space-y-2"}>
						<Dialog.Title className="DialogTitle">
							Edit Group
						</Dialog.Title>
						<Input
							autoFocus
							placeholder={"Title"}
							value={title}
							className={"bg-secondary/30"}
							onChange={(e) => setTitle(e.target.value)}
						/>
						<div
							className={
								"flex justify-between items-center pt-4"
							}
						>
							<div>
								<Button
									variant={"destructive"}
									onClick={handleDelete}
								>
									Delete
								</Button>
							</div>
							<div className="flex gap-4">
								<Button onClick={handleUpdate}>
									Update
								</Button>
								<Button
									variant={"ghost"}
									onClick={handleClose}
								>
									Cancel
								</Button>
							</div>
						</div>
					</div>
				</Dialog.Content>
			</Dialog.Portal>
		</Dialog.Root>
	);
};

export { EditGroupDialog };
